import styled from "styled-components";

import fonts from "core/fonts";

export const Item = styled.li`
    display: block;
    ${fonts.typeScale[14]};
    color: ${fonts.fontColors.light.primary};
`;
